import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Switch } from '@producer/ui-kit';

import { DescriptionHeader } from '../../features/user/components/description-header';
import { SettingsAction } from '../../features/user/components/settings-action';
import { api } from '../../api';
import { EnvelopeClosedIcon } from '@radix-ui/react-icons';
import { toastPool } from '../../features/toasts/models/toast-pool';
import { Toast } from '../../features/toasts/models/toast';
import { uiStore } from '../../core/stores/ui-store';

export const NotificationPage = observer(() => {
  const [preferences, setPreferences] = useState();

  useEffect(() => {
    uiStore.pageTitle = {
      label: 'Notifications settings',
    };

    return () => {
      uiStore.pageTitle = {
        label: '',
      };
    };
  });

  useEffect(() => {
    api.get('/me/notifications/preferences').then((res) => {
      setPreferences(res.data);
    });
  }, []);

  const handleUpdatePreference = () => {

    if(!preferences) {
      return;
    }

    console.log(preferences);


    api
      .patch('/me/notifications/preferences', {
        channels: {
          email: !preferences?.global.channels.email,
        },
      })
      .then(({ data }) => {
        setPreferences(data);
      })
      .catch(() => {
        toastPool.insert(
          new Toast('Could not update notification preferences, try again later.', 'error'),
        );
      });
  };

  if (!preferences) {
   return null;
  }

  return (
    <>
      <DescriptionHeader
        title={'Notifications'}
        description={'Select where you will be notified.'}
      />

      <SettingsAction
        title={'Email notifications'}
        icon={<EnvelopeClosedIcon />}
        action={
          <Switch isToggled={preferences.global.channels.email} onToggle={handleUpdatePreference} />
        }
      />
    </>
  );
});
